import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './Context/GlobalContext';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <GlobalProvider>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </GlobalProvider>
  </BrowserRouter>
);

reportWebVitals();
